'use es6';

import PropTypes from 'prop-types';
const BASE_CLASS_NAME = 'interstitial-content-viewport';
import ContentViewport from '../ContentViewport';
import { jsx as _jsx } from "react/jsx-runtime";
const InterstitialContentViewport = ({
  use,
  children,
  wrapperClassName,
  wrapperStyle
}) => /*#__PURE__*/_jsx(ContentViewport, {
  wrapperClassName: `${BASE_CLASS_NAME} ${BASE_CLASS_NAME}--${use} ${wrapperClassName}`,
  wrapperStyle: wrapperStyle,
  children: children
});
InterstitialContentViewport.defaultProps = {
  use: 'info'
};
InterstitialContentViewport.propTypes = {
  children: PropTypes.node.isRequired,
  use: PropTypes.oneOf(['success', 'info']),
  wrapperClassName: PropTypes.string,
  wrapperStyle: PropTypes.object
};
export default InterstitialContentViewport;